import { render, staticRenderFns } from "./MasterFieldList.vue?vue&type=template&id=a165fb74&scoped=true&"
import script from "./MasterFieldList.vue?vue&type=script&lang=ts&"
export * from "./MasterFieldList.vue?vue&type=script&lang=ts&"
import style0 from "./MasterFieldList.vue?vue&type=style&index=0&id=a165fb74&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a165fb74",
  null
  
)

export default component.exports